document.addEventListener("DOMContentLoaded", () => {
  if (typeof Swiper === "undefined") return;

  const topSwipers = document.querySelectorAll(".top-swiper");
  if (topSwipers.length === 0) return;

  // .top-swiper が複数あっても各要素ごとに初期化する
  topSwipers.forEach((el) => {
    const nextEl = el.querySelector(".swiper-button-next");
    const prevEl = el.querySelector(".swiper-button-prev");

    new Swiper(el, {
      loop: true,
      slidesPerView: 2,
      spaceBetween: 9,
      navigation:
        nextEl && prevEl
          ? {
              nextEl,
              prevEl,
            }
          : undefined,
      breakpoints: {
        769: {
          slidesPerView: 3,
          spaceBetween: 50,
        },
      },
    });
  });
});
